import { render, staticRenderFns } from "./EditAddressModal.vue?vue&type=template&id=afac937a&scoped=true"
import script from "./EditAddressModal.vue?vue&type=script&lang=js"
export * from "./EditAddressModal.vue?vue&type=script&lang=js"
import style0 from "./EditAddressModal.vue?vue&type=style&index=0&id=afac937a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afac937a",
  null
  
)

export default component.exports